export default (current, next) => current.concat(next);
